import { createGetAPI, createPatchAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

import { BASE_URL } from '../constants/api';

const { useGet: useStudentsGetOfParent } = createGetAPI({
  getURL: (parenServiceId, query) =>
    `${BASE_URL}/parents/${parenServiceId}/student/?${stringify(query)}`,
});

const { usePatch: useToggleStripe } = createPatchAPI({
  getURL: parenServiceId => `${BASE_URL}/parents/${parenServiceId}/toggle-stripe`,
});

const { usePatch: useParentOpportunityCountryUpdate } = createPatchAPI({
  getURL: parenServiceId => `${BASE_URL}/parents/${parenServiceId}/opportunity-country`,
});

export { useStudentsGetOfParent, useToggleStripe, useParentOpportunityCountryUpdate };
